import { Injector } from '@angular/core';
import { ButtonActionType, UiZoneWidgetAttributeConfig } from '@finxone-platform/shared/sys-config-types';
import { functionCtaType } from '../cta-button-actions.utils';
import { trackFeedbackCounter } from '../generic-actions/feedback-counter.utils';

export const feedbackCounterActions: Map<ButtonActionType, functionCtaType> = new Map([
  [
    ButtonActionType.FEEDBACK_COUNTER,
    (injector: Injector, attri: UiZoneWidgetAttributeConfig) => {
      trackFeedbackCounter(injector, attri.widgetProperties);
    },
  ],
]);
